import SnowflakeId from './snowflake';

export { SnowflakeId };

export default {
  SnowflakeId,
};
